import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "sonner";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import SelectRole from "./pages/SelectRole";
import AppShell from "./components/AppShell";
import Dashboard from "./pages/Dashboard";
import Leads from "./pages/modules/Leads";
import Admissions from "./pages/modules/Admissions";
import Identity from "./pages/modules/Identity";
import Fees from "./pages/modules/Fees";
import SIS from "./pages/modules/SIS";
import LMS from "./pages/modules/LMS";
import Attendance from "./pages/modules/Attendance";
import Campus from "./pages/modules/Campus";
import Parent from "./pages/modules/Parent";
import Exams from "./pages/modules/Exams";
import Proctoring from "./pages/modules/Proctoring";
import Placements from "./pages/modules/Placements";
import Alumni from "./pages/modules/Alumni";
import Reports from "./pages/modules/Reports";
import Cohort from "./pages/Cohort";
import QuizRunner from "./pages/QuizRunner";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.role) return <Navigate to="/onboarding" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Synchronous detection — must run during render, BEFORE Routes
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/onboarding" element={<SelectRole />} />
      <Route element={<Protected><AppShell /></Protected>}>
        <Route path="/app" element={<Dashboard />} />
        <Route path="/app/leads" element={<Leads />} />
        <Route path="/app/admissions" element={<Admissions />} />
        <Route path="/app/identity" element={<Identity />} />
        <Route path="/app/fees" element={<Fees />} />
        <Route path="/app/sis" element={<SIS />} />
        <Route path="/app/lms" element={<LMS />} />
        <Route path="/app/attendance" element={<Attendance />} />
        <Route path="/app/campus" element={<Campus />} />
        <Route path="/app/parent" element={<Parent />} />
        <Route path="/app/exams" element={<Exams />} />
        <Route path="/app/proctoring" element={<Proctoring />} />
        <Route path="/app/placements" element={<Placements />} />
        <Route path="/app/alumni" element={<Alumni />} />
        <Route path="/app/reports" element={<Reports />} />
        <Route path="/app/cohort/:tag" element={<Cohort />} />
        <Route path="/app/quiz/:quiz_id" element={<QuizRunner />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
